import { Group, Paper, Text } from "@mantine/core";
import React from "react";
import { Trash } from "tabler-icons-react";
import Button from "../Button";
import { deleteData } from "./deleteData";

const DeleteModalContent = ({
  type,
  setOpened,
  route,
  setUpdate,
  setLoading,
}) => {
  console.log("DeleteModalContent");
  console.log("type", type);
  console.log("route", route);

  return (
    <Paper>
      <Text
        size="xl"
        align="center"
        weight="bold"
      >{`Are You Sure You Want To Delete This ${type}?`}</Text>
      <Group position="center" spacing="xl" my="xl">
        <Button
          primary={false}
          title="No, Don't Delete"
          onClick={() => {
            setOpened(false);
          }}
        />
        <Button
          primary={true}
          title="Yes, Delete"
          icon={<Trash />}
          onClick={() => {
            setOpened(false);
            setLoading(true);
            deleteData(setUpdate, route, setOpened);

            console.log("clicked");
          }}
        />
      </Group>
    </Paper>
  );
};

export default DeleteModalContent;
